import gql from 'graphql-tag';

export const ListNotificationQuery = gql`
  query ListNotificationQuery {
    notifications{
      id
      content
      name
      closeNotification
      checkTagsAND
      checkTagsOR
      programTypes
      dashboardTypes
      showDashboardTypes_Formatted
      tags_Formatted
      __typename
    }
  }
`;



export const GetContactNotifications = gql`
query GetContactNotifications($contactId: String) {
  getContactNotifications(contactId: $contactId){
    id
    name
    content
    closeNotification
    checkTagsAND
    checkTagsOR
    dashboardTypes
    programTypes
    showDashboardTypes_Formatted
    tags_Formatted
    __typename
  }
}
`;